module.exports = __webpack_public_path__ + "img/policy-4.78ddad10.png";